// extracted by css-extract-rspack-plugin
var _1 = "termsField__LBV0Y";
var _2 = "termsField__checkbox__oA2zI";
var _3 = "termsField__helpText__S1Xfe";
var _4 = "termsField__helpText__description__CJWal";
var _5 = "termsField__helpText__label__cnzqT";
export { _1 as "termsField", _2 as "termsField__checkbox", _3 as "termsField__helpText", _4 as "termsField__helpText__description", _5 as "termsField__helpText__label" }
export default { "termsField": _1, "termsField__checkbox": _2, "termsField__helpText": _3, "termsField__helpText__description": _4, "termsField__helpText__label": _5 }
